export default "__VITE_ASSET__D7JyfUT0__"